const SET_NEWS_CATEGORY = 'SET_NEWS_CATEGORY'
const SET_TAG = 'SET_TAG'
const SET_POST_PREVIEW = 'SET_POST_PREVIEW'

const state = {
  newsCategory: null,
  activeTag: '1',
  postPreview: null
}

const mutations = {
  [SET_NEWS_CATEGORY]: (state, value) => {
    state.newsCategory= value
  },
  [SET_TAG]: (state, value) => {
    state.activeTag = value
  },
  [SET_POST_PREVIEW]: (state, value) => {
    state.postPreview = value
  }
}

const actions = {
  setNewsCategory({ commit }, val) {
    commit(SET_ALL_QUOTE, val)
  },
  setTag({ commit }, val) {
    commit(SET_TAG, val)
  },
  setPostPreview({ commit }, val) {
    commit(SET_POST_PREVIEW, val)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}